export const tenantLogoTooltip = "qnxxle";
export const shyHeaderAriaLabel = "i7WhP";
export const appLauncherButtonLabel = "Pup3Ue";
export const overflowMenuButtonTooltip = "ec$t9";
export default {tenantLogoTooltip,shyHeaderAriaLabel,appLauncherButtonLabel,overflowMenuButtonTooltip};